"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadButton = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("../../../shared/core");
var analytics_subjects_1 = require("../analytics-subjects");
var copy_1 = require("../copy");
var date_1 = require("../utils/date");
var StyledTextLink = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > span {\n    display: flex;\n    align-items: center;\n    > svg {\n      margin-right: 4px;\n    }\n  }\n"], ["\n  > span {\n    display: flex;\n    align-items: center;\n    > svg {\n      margin-right: 4px;\n    }\n  }\n"])));
var DownloadButton = function (_a) {
    var _b;
    var downloadUrl = _a.downloadUrl, endDate = _a.endDate, _c = _a.asText, asText = _c === void 0 ? false : _c, _d = _a.isLatestBill, isLatestBill = _d === void 0 ? false : _d, handleDownloadClick = _a.handleDownloadClick;
    var _e = (0, core_1.useComponents)(), SecondaryCTALink = _e.SecondaryCTALink, Icon = _e.Icon, TextLink = _e.TextLink;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var linkProps = {
        iconLeft: 'download',
        iconRight: 'off',
        'data-testid': 'download-link',
        href: downloadUrl,
        download: true,
    };
    var linkContent = (react_1.default.createElement(react_1.default.Fragment, null,
        asText && react_1.default.createElement(Icon, { name: "download" }),
        react_1.default.createElement("span", null, copy('download'))));
    return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.DOWNLOAD_BILL, properties: (_b = {},
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b.isLatest = isLatestBill,
            _b.periodEnd = (0, date_1.formatDateToIso)(endDate),
            _b) }, asText ? (handleDownloadClick ? (react_1.default.createElement(StyledTextLink, __assign({ as: TextLink, onClick: function (e) {
            e.preventDefault();
            handleDownloadClick();
        } }, linkProps), linkContent)) : (react_1.default.createElement(StyledTextLink, __assign({ as: TextLink }, linkProps), linkContent))) : handleDownloadClick ? (react_1.default.createElement(SecondaryCTALink, __assign({ onClick: function (e) {
            e.preventDefault();
            handleDownloadClick();
        } }, linkProps), linkContent)) : (react_1.default.createElement(SecondaryCTALink, __assign({}, linkProps), linkContent))));
};
exports.DownloadButton = DownloadButton;
var templateObject_1;
